import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Link, Box } from '@mui/material';
import { Link as RouterLink, useLocation, useParams } from 'react-router';
import { Home, ChevronRight } from '@mui/icons-material';

const Breadcrumbs = () => {
  const location = useLocation();
  const params = useParams();

  const routeMap = {
    '/onboarding': 'Account Onboarding',
    '/accounts': 'Accounts',
    '/manufacturers': 'Manufacturers', 
    '/manufacturer-accounts': 'Monitored Accounts',
    '/users': 'User Management'
  };

  const getBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Dashboard', path: '/onboarding', icon: <Home sx={{ fontSize: 16 }} /> }];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Skip ID segments in breadcrumbs
      if (!isNaN(segment)) return;
      
      const label = routeMap[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1);
      breadcrumbs.push({ label, path: currentPath });
    });

    // Add edit context if ID is present
    if (params.id) {
      const basePath = pathSegments[0];
      const editLabel = basePath === 'onboarding' ? 'Edit Account' : 
                      basePath === 'accounts' ? 'Edit Account' :
                      basePath === 'manufacturers' ? 'Edit Manufacturer' :
                      basePath === 'manufacturer-accounts' ? 'Edit Configuration' :
                      basePath === 'users' ? 'Edit User' : 'Edit';
      breadcrumbs.push({ label: editLabel, path: location.pathname, isActive: true });
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  if (breadcrumbs.length <= 1) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs 
        separator={<ChevronRight sx={{ fontSize: 16 }} />}
        sx={{ 
          '& .MuiBreadcrumbs-separator': { mx: 1 },
          '& .MuiBreadcrumbs-li': { display: 'flex', alignItems: 'center' }
        }}
      >
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          if (isLast || crumb.isActive) {
            return (
              <Typography
                key={crumb.path}
                sx={{
                  color: "text.primary",
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  fontWeight: 500,
                  fontSize: '0.875rem'
                }}>
                {crumb.icon}
                {crumb.label}
              </Typography>
            );
          }

          return (
            <Link
              key={crumb.path}
              component={RouterLink}
              to={crumb.path}
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                textDecoration: 'none',
                color: 'text.secondary',
                fontSize: '0.875rem',
                '&:hover': { 
                  textDecoration: 'underline',
                  color: 'primary.main'
                }
              }}
            >
              {crumb.icon}
              {crumb.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;